module.exports = __webpack_public_path__ + "img/Online Consultation.2436ba18.svg";